var map = {
	"./fortuneIcon.svg": 781,
	"./fortuneIconL.svg": 782,
	"./helpdeskIcon.svg": 783,
	"./helpdeskIconL.svg": 784,
	"./homeIcon.svg": 785,
	"./homeIconLarge.svg": 786,
	"./jackpotIcon.svg": 787,
	"./logo.svg": 788,
	"./logoSmall.svg": 789,
	"./loyaltyIcon.svg": 790,
	"./mobileAppIcon.svg": 791,
	"./profileIcon.svg": 792,
	"./questIcon.svg": 793,
	"./rewardLineupIcon.svg": 794,
	"./searchIcon.svg": 795,
	"./searchIconLarge.svg": 796,
	"./signOutIcon.svg": 797,
	"./star.svg": 798,
	"./tournamentIcon.svg": 799,
	"./tournamentLargeIcon.svg": 800,
	"./vipIcon.svg": 801,
	"./wheelIcon.svg": 802,
	"./wheelIconL.svg": 803,
	"./wheelIconMobile.svg": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;